import { render, staticRenderFns } from "./DigitalProduct.vue?vue&type=template&id=44d10eab&scoped=true"
import script from "./DigitalProduct.vue?vue&type=script&lang=js"
export * from "./DigitalProduct.vue?vue&type=script&lang=js"
import style0 from "./DigitalProduct.vue?vue&type=style&index=0&id=44d10eab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d10eab",
  null
  
)

export default component.exports